/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { savePersonaJuridica } from "../../../project/services/PersonaJuridicaService";
import { getCondicionesFrenteIva } from "../../../project/services/CondicionFrenteIvaService";
import { getDepartamentos } from "../../../project/services/DepartamentoService";
import { getProvincias } from "../../../project/services/ProvinciaService";
import { getPaises } from "../../../project/services/PaisService";
import { isPositiveInteger, onlyLettersAndSpaces, isValidEmail } from "../../../project/utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id: "",
  condicionFrenteIva: "",
  numeroCuit: "",
  razonSocial: "",
  domicilio: "",
  localidad: "",
  departamento: "",
  provincia: "",
  pais: "",
  codigoPostal: "",
  eMail: "",
  telefonoMovil: "",
  telefonoFijo: "",
};

const nameItemText = "Persona Jurídica";
const itemGender = "F";
// const elLa = itemGender === "M" ? "el" : "la";
// const unUna = itemGender === "M" ? "un" : "una";
//
// ###########################################################################
//
const PersonaJuridicaDialog = ({ onSave, onClose, itemCrud, actionCrud, setMessage, setShowMessage }) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [condicionesFrenteIva, setCondicionesFrenteIva] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [paises, setPaises] = useState([]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadCondicionesFrenteIva();
    loadDepartamentos();
    loadProvincias();
    loadPaises();
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const loadCondicionesFrenteIva = async () => {
    const response = await getCondicionesFrenteIva();
    if (response.ok) {
      setCondicionesFrenteIva(response.data.data);
    } else {
      setCondicionesFrenteIva([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadDepartamentos = async () => {
    const response = await getDepartamentos();
    if (response.ok) {
      setDepartamentos(response.data.data);
    } else {
      setDepartamentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProvincias = async () => {
    const response = await getProvincias();
    if (response.ok) {
      setProvincias(response.data.data);
    } else {
      setProvincias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadPaises = async () => {
    const response = await getPaises();
    if (response.ok) {
      setPaises(response.data.data);
    } else {
      setPaises([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {

      if (itemCrudLocal.condicionFrenteIva === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar una condición frente al IVA",
        });
        setShowMessage(true);
        return;
      }

      if (
        !isPositiveInteger(itemCrudLocal.numeroCuit) ||
        itemCrudLocal.numeroCuit.length < 11
      ) {
        setMessage({
          severity: "error",
          messageText: "El CUIT debe ser ingresado sin guiones ni espacios",
        });
        setShowMessage(true);
        return;
      }

      if (
        itemCrudLocal.razonSocial === "" ||
        itemCrudLocal.razonSocial.length < 3 ||
        !onlyLettersAndSpaces(itemCrudLocal.razonSocial)
      ) {
        setMessage({
          severity: "error",
          messageText: "La Razón Social no es válida",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.eMail !== "" && !isValidEmail(itemCrudLocal.eMail)) {
        setMessage({
          severity: "error",
          messageText: "El mail no es válido",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {
    let _itemCrud = {
      id_condicion_frente_iva: itemCrudLocal.condicionFrenteIva,
      numero_cuit: itemCrudLocal.numeroCuit,
      razon_social: itemCrudLocal.razonSocial,
      email: itemCrudLocal.eMail,
      telefono_movil: itemCrudLocal.telefonoMovil,
      telefono: itemCrudLocal.telefonoFijo,
      domicilio: itemCrudLocal.domicilio,
      localidad: itemCrudLocal.localidad,
      id_departamento: itemCrudLocal.departamento || null,
      id_provincia: itemCrudLocal.provincia || null,
      id_pais: itemCrudLocal.pais || null,
      codigo_postal: itemCrudLocal.codigoPostal,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await savePersonaJuridica(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={6} lg={6}>
                {/* condicion frente al iva */}

                {condicionesFrenteIva.length > 0 && (
                  <FormControl
                    disabled={actionCrud !== "new"}
                    sx={{ mb: 1, width: "100%" }}
                  >
                    <InputLabel id="condicion-frente-iva-select-label">Condición frente al IVA</InputLabel>
                    <Select
                      labelId="condicion-frente-iva-select-label"
                      id="condicion-frente-iva-select"
                      name="condicionFrenteIva"
                      value={itemCrudLocal.condicionFrenteIva}
                      label="Condición frente al IVA"
                      size="small"
                      onChange={handleChange}
                    >
                      {condicionesFrenteIva.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>

              {/* numero de cuit */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="numero-cuit"
                  label="Número de CUIT (sin guiones ni espacios)"
                  variant="outlined"
                  size="small"
                  name="numeroCuit"
                  value={itemCrudLocal.numeroCuit}
                  onChange={handleChange}
                  disabled={actionCrud !== "new"}
                />
              </Grid>

              {/* razon Social */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="razonSocial"
                  label="Razón Social"
                  variant="outlined"
                  size="small"
                  name="razonSocial"
                  value={itemCrudLocal.razonSocial}
                  onChange={handleChange}
                />
              </Grid>

              {/* domicilio */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="domicilio"
                  label="Domicilio"
                  variant="outlined"
                  size="small"
                  name="domicilio"
                  value={itemCrudLocal.domicilio}
                  onChange={handleChange}
                />
              </Grid>

              {/* localidad  */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="localidad"
                  label="Localidad"
                  variant="outlined"
                  size="small"
                  name="localidad"
                  value={itemCrudLocal.localidad}
                  onChange={handleChange}
                />
              </Grid>

              {/* departamento */}

              <Grid item xs={12} md={6} lg={6}>

                {departamentos.length > 0 && (
                  <FormControl sx={{ width: "100%", mb: 1 }}>
                    <InputLabel id="departamento-select-label">Departamento</InputLabel>
                    <Select
                      labelId="departamento-select-label"
                      id="departamento-select"
                      name="departamento"
                      value={itemCrudLocal.departamento}
                      label="Departamento"
                      size="small"
                      onChange={handleChange}
                      MenuProps={{ style: { maxHeight: "300px" } }}
                    >
                      {departamentos.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>

              {/* provincia */}

              <Grid item xs={12} md={6} lg={6}>
                {provincias.length > 0 && (
                  <FormControl sx={{ width: "100%", mb: 1 }}>
                    <InputLabel id="provincia-select-label">Provincia</InputLabel>
                    <Select
                      labelId="provincia-select-label"
                      id="provincia-select"
                      name="provincia"
                      value={itemCrudLocal.provincia}
                      label="provincia"
                      size="small"
                      onChange={handleChange}
                      MenuProps={{ style: { maxHeight: "300px" } }}
                    >
                      {provincias.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>

              {/* pais */}

              <Grid item xs={12} md={6} lg={6}>
                {paises.length > 0 && (
                  <FormControl sx={{ width: "100%", mb: 1 }}>
                    <InputLabel id="pais-select-label">País</InputLabel>
                    <Select
                      labelId="pais-select-label"
                      id="pais-select"
                      name="pais"
                      value={itemCrudLocal.pais}
                      label="pais"
                      size="small"
                      onChange={handleChange}
                      MenuProps={{ style: { maxHeight: "300px" } }}
                    >
                      {paises.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>

              {/* codigo postal */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoPostal"
                  label="Código Postal"
                  variant="outlined"
                  size="small"
                  name="codigoPostal"
                  value={itemCrudLocal.codigoPostal}
                  onChange={handleChange}
                />
              </Grid>

              {/* email */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="eMail"
                  label="E-Mail"
                  variant="outlined"
                  size="small"
                  name="eMail"
                  value={itemCrudLocal.eMail}
                  onChange={handleChange}
                />
              </Grid>

              {/* telefono movil */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="telefonoMovil"
                  label="Teléfono Móvil"
                  variant="outlined"
                  size="small"
                  name="telefonoMovil"
                  value={itemCrudLocal.telefonoMovil}
                  onChange={handleChange}
                />
              </Grid>

              {/* telefono fijo */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="telefonoFijo"
                  label="Teléfono Fijo"
                  variant="outlined"
                  size="small"
                  name="telefonoFijo"
                  value={itemCrudLocal.telefonoFijo}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Button
              sx={{ mr: 1, backgroundColor: "warning" }}
              variant="contained"
              onClick={handleSave}
              startIcon={
                actionCrud === "disable" ? (
                  <RemoveCircleOutlineIcon />
                ) : actionCrud === "enable" ? (
                  <AddCircleOutlineIcon />
                ) : (
                  <SaveIcon />
                )
              }
            >
              {actionCrud === "disable"
                ? "Deshabilitar"
                : actionCrud === "enable"
                  ? "Habilitar"
                  : "Guardar"}
            </Button>
            <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
              Cancelar
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default PersonaJuridicaDialog;
